import React, { Fragment } from 'react'
import BasePage from './BasePage';
import { connect } from 'react-redux';
import {setModalContent} from '../actionCreators';
import Menu from '../components/Menu';
import Modal from '../components/Modal';
import ClientSelector from '../components/ClientSelector.js';
import ArticleSelector from '../components/ArticleSelector.js';
import BillSelector from '../components/BillSelector.js';
import ServidorAeatInfo from '../components/ServidorAeatInfo';
import { DateTimePickerComponent } from '@syncfusion/ej2-react-calendars';

import logo from '../img/logo-menu.png';
import ReactToPrint from 'react-to-print'
import QRCode from 'react-qr-code'
import configData from '../config.json'

import $ from 'jquery';

function prettyXml(xmlStr) {
	if (!xmlStr) return '';
	try {
		const PAD = '  ';
		let pad = 0;
		const lines = xmlStr.replace(/(>)(<)(\/*)/g, '$1\n$2$3').split('\n');
		return lines.map(raw => {
			const node = raw.trim();
			if (!node) return '';
			const isClose     = /^<\/\w/.test(node);
			const isSelfClose = /\/>$/.test(node) || /^<\?/.test(node);
			const isOpen      = !isClose && !isSelfClose && /^<\w/.test(node);
			const isInline    = /^<\w[^>]*>[^<]+<\/\w/.test(node);
			if (isClose) pad = Math.max(0, pad - 1);
			const line = PAD.repeat(pad) + node;
			if (isOpen && !isInline) pad++;
			return line;
		}).filter(Boolean).join('\n');
	} catch(e) { return xmlStr; }
}

class EditBill extends BasePage {

    loadOnConstructor(){
		this.getBillInterface = this.getBillInterface.bind(this);
		this.cancelButton = this.cancelButton.bind(this);
		this.saveButton = this.saveButton.bind(this);
		this.validateBillLines = this.validateBillLines.bind(this);
		this.updateBillCallback = this.updateBillCallback.bind(this);
		this.newBillCallback = this.newBillCallback.bind(this);
		this.handleChange = this.handleChange.bind(this);
		this.addArticle = this.addArticle.bind(this);
		this.parseResponse = this.parseResponse.bind(this);
		this.stringBackToStringFront = this.stringBackToStringFront.bind(this);
		this.initializeRefs = this.initializeRefs.bind(this);
		this.clientSelectedCallback = this.clientSelectedCallback.bind(this);
		this.articleSelectedCallback = this.articleSelectedCallback.bind(this);
		this.billSelectedCallback = this.billSelectedCallback.bind(this);
		this.renderBillLines = this.renderBillLines.bind(this);
		this.renderLine = this.renderLine.bind(this);
		this.addLine = this.addLine.bind(this);
		this.dropLine = this.dropLine.bind(this);
		this.recalculateBillPrices = this.recalculateBillPrices.bind(this);
		this.renderTaxValues = this.renderTaxValues.bind(this);
		this.displayBillHeader = this.displayBillHeader.bind(this);
		this.displayBillBody = this.displayBillBody.bind(this);
		this.loadVerifactuLog = this.loadVerifactuLog.bind(this);
		this.handleVerifactuLog = this.handleVerifactuLog.bind(this);
		this.reencolar = this.reencolar.bind(this);
		this.handleReencolar = this.handleReencolar.bind(this);
		this.handleVerXml = this.handleVerXml.bind(this);
		this._verifactuPollTimeout = null;
		this.adjustDateToTimezone = this.adjustDateToTimezone.bind(this);
		this.anularEnVerifactu = this.anularEnVerifactu.bind(this);
		this.anularEnVerifactuCallback = this.anularEnVerifactuCallback.bind(this);
		this.saveEstadoVencimiento = this.saveEstadoVencimiento.bind(this);
		this.saveEstadoVencimientoCallback = this.saveEstadoVencimientoCallback.bind(this);
		this.convertToPdfDate = this.convertToPdfDate.bind(this);

		this.initializeRefs();

		const {bill_id, duplicate_id} = this.getUrlParams();
		if(bill_id !== undefined){
			this.state = {action: 'modify', verifactuModalOpen: false};
			this.getBillInterface(bill_id);
		}else if(duplicate_id !== undefined){
			this.state = {action: 'duplicate', isSaving: false, verifactuModalOpen: false};
			this.getBillInterface(duplicate_id);
		}else{
			this.state = {action: 'new', isSaving: false, verifactuModalOpen: false};
			this.getBillInterface();
		}
    }

	initializeRefs(){
		this.clientSel = React.createRef();
		this.clientInput = React.createRef();
		this.billSel = React.createRef();

		this.clientInputValue = {};
		this.deletedClient = false;
		this.clientFromBill = false;

		this.articleSel = React.createRef();
		this.articleInput = React.createRef();

		this.articleInputValue = {};
		this.deletedArticle = false;
		this.articleFromBill = false;
	}

    getBillInterface(billId){
		const api = this.getApi();
		api.getEditBillInterface(billId, this.parseResponse);
    }

    parseResponse(response){
		if(response.hasOwnProperty('auth') && response.auth === false){
			this.navigateTo('/login');
			return;
		}

		if(response.status === 'OK'){
			if(this.state.action === 'modify' || this.state.action === 'duplicate'){

				if(this.state.action === 'modify'){
					response.bill.creation_date = this.stringBackToStringFront(response.bill.creation_date);
					response.bill.expiration_date = response.bill.expiration_date !== undefined?
					this.adjustDateToTimezone(response.bill.expiration_date, true):undefined
					
				}else if(this.state.action === 'duplicate'){
					delete response.bill.expiration_date
					delete response.bill.creation_date
					delete response.bill.status
					delete response.bookings
				}

				response.bill.client = response.bill.client._id

				response.bill.lines = response.bill.lines.map((line,idx) => {
					delete line._id
					if(line.article !== undefined && line.article !== null) {
						line.completeArticle = JSON.parse(JSON.stringify(line.article))
						line.article = line.completeArticle._id
					}
					return line
				})

				this.setState(prevState => {
					return {
						...prevState,
						bill: response.bill,
						selectedClient: response.selectedClient,
						taxes: response.taxes,
						operations: response.operations,
						bookings: response.bookings !== undefined?response.bookings:[],
						i18n: response.i18n
					}
				});
				this.loadVerifactuLog(response.bill._id);
			}else{
				this.setState(prevState => {
					return {
						...prevState,
						bill: {lines:[{quantity:1}]},
						taxes: response.taxes,
						operations: response.operations,
						i18n: response.i18n
					}
				});
			}
		}else{
			this.props.setModalContent({
				title: this.getTrad('messageFromServer'),
				body: [this.getTrad(response.message)],
				buttons: [
					{shown: 'Aceptar', behaviour: 'main', close: true }
				]
			});

			$("#exampleModal").modal('toggle');
			return;
		}
	}

	adjustDateToTimezone(dateObject, fromServer, toISOString){
		let modifiedDateObject = new Date(typeof dateObject === 'object'?dateObject.getTime():dateObject);
		let hoursFromTimezoneOffset = (modifiedDateObject.getTimezoneOffset()*-1) / 60;

		hoursFromTimezoneOffset = fromServer?hoursFromTimezoneOffset*-1:hoursFromTimezoneOffset

		modifiedDateObject.setHours(modifiedDateObject.getHours()+hoursFromTimezoneOffset);

		return toISOString?modifiedDateObject.toISOString():modifiedDateObject;
	}

	roundValues(originalValue){

		return Math.round(originalValue * 100) / 100
	}


	stringBackToStringFront(originalStr){
		const objDate = new Date(originalStr);

		return objDate.getUTCFullYear() + "-" +
			("0" + (objDate.getUTCMonth()+1)).slice(-2) + "-" +
			("0" + objDate.getUTCDate()).slice(-2) + " " +
			("0" + objDate.getUTCHours()).slice(-2) + ":" +
			("0" + objDate.getUTCMinutes()).slice(-2) + ":" +
			("0" + objDate.getUTCSeconds()).slice(-2);
	}

	convertToPdfDate(date, includeTime){
		const objDate = new Date(date);

		return ("0" + objDate.getUTCDate()).slice(-2) + '/' +
			("0" + (objDate.getUTCMonth()+1)).slice(-2) + '/' +
			objDate.getUTCFullYear() + 
				(includeTime?' '+("0" + objDate.getUTCHours()).slice(-2) + ":" +
				("0" + objDate.getUTCMinutes()).slice(-2) + ":" +
				("0" + objDate.getUTCSeconds()).slice(-2):'')
	}

	componentWillUnmount() {
		if (this._verifactuPollTimeout) clearTimeout(this._verifactuPollTimeout);
	}

	loadVerifactuLog(billId) {
		if (!billId) return;
		this._verifactuBillId = billId;
		const api = this.getApi();
		api.getVerifactuLog(billId, this.handleVerifactuLog);
	}

	handleVerifactuLog(response) {
		if (!response || response.status !== 'OK') return;
		const latest = Array.isArray(response.queue) ? response.queue[0] : null;
		const pending = latest && ['pending', 'processing', 'retrying'].includes(latest.status);
		const hayAnulacionEnCola = Array.isArray(response.queue) &&
			response.queue.some(e => e.operacion === 'anulacion' && ['pending', 'processing', 'retrying'].includes(e.status));
		this.setState(prevState => ({
			verifactuLog: response,
			bill: {
				...prevState.bill,
				...(response.verifactu_status != null ? { verifactu_status: response.verifactu_status } : {}),
				...(response.anulada ? { anulada: true } : {})
			}
		}));
		// Seguir sondeando si hay items pendientes, anulación en vuelo, o verifactu_status aún nulo.
		// Parar si la factura ya está anulada confirmada.
		if (!response.anulada && (pending || hayAnulacionEnCola || response.verifactu_status === null)) {
			this._verifactuPollTimeout = setTimeout(() => this.loadVerifactuLog(this._verifactuBillId), 10000);
		}
	}

	reencolar() {
		const id = this.state.bill?._id;
		if (!id || this.state.reencolando) return;
		this.setState({ reencolando: true });
		const api = this.getApi();
		api.verifactuReencolar(id, this.handleReencolar);
	}

	handleReencolar(response) {
		if (response?.status === 'OK') {
			this.setState({ reencolando: false, reencolarError: null });
			this.loadVerifactuLog(this.state.bill._id);
		} else {
			this.setState({ reencolando: false, reencolarError: response?.message || 'Error al reencolar la factura' });
		}
	}

	handleVerXml(queueId) {
		const api = this.getApi();
		api.getVerifactuQueueXml(queueId, (response) => {
			if (response.status === 'OK') {
				this.setState({ xmlModal: { queueId, xml_sent: response.xml_sent, xml_received: response.xml_received, queue_status: response.queue_status, servidor_aeat: response.servidor_aeat, tab: 'sent' } });
			} else {
				alert(response.message || 'Error cargando XML');
			}
		});
	}

	cancelButton(){
		this.goBack();
    }

	anularEnVerifactu(){
		this.props.setModalContent({
			title: 'Anular factura en Verifactu',
			body: [
				'Se enviará un registro de anulación a la AEAT a través de Verifactu.',
				'La factura quedará marcada como anulada cuando la AEAT confirme la operación. El registro se conserva para consulta.'
			],
			buttons: [
				{shown: 'Anular en Verifactu', behaviour: 'main', close: true, callback: () => {
					const api = this.getApi();
					api.verifactuAnular(this.state.bill._id, this.anularEnVerifactuCallback);
				}},
				{shown: 'Cancelar', close: true},
			]
		});
		$("#exampleModal").modal('toggle');
	}

	anularEnVerifactuCallback(response){
		setTimeout(() => {
			if (response && response.status === 'OK') {
				// Arrancar polling inmediatamente — no esperar a que el usuario cierre el modal
				this.loadVerifactuLog(this.state.bill._id);
				this.props.setModalContent({
					title: 'Anulación encolada',
					body: ['La anulación se ha enviado a la cola de Verifactu. Cuando la AEAT confirme, la factura quedará marcada como anulada automáticamente.'],
					buttons: [{shown: 'Aceptar', behaviour: 'main', close: true}]
				});
			} else {
				this.props.setModalContent({
					title: 'No se ha podido encolar la anulación',
					body: [response?.message || 'Error desconocido'],
					buttons: [{shown: 'Aceptar', behaviour: 'main', close: true}]
				});
			}
			$("#exampleModal").modal('toggle');
		}, 400);
	}

	// Una factura existente ya se ha enviado a Verifactu al crearse: solo admite cambios de estado y vencimiento
	esSoloLectura(){
		return this.state.action === 'modify'
	}

	// Guarda solo estado y fecha de vencimiento, los únicos campos editables tras enviar la factura a Verifactu
	saveEstadoVencimiento(){
		if (this._saving) return;

		const bill = this.state.bill
		const errores = []
		if(bill.status === '0' || bill.status === undefined){
			errores.push(this.getTrad('fillBillStatus'))
		}
		// En una factura anulada solo se puede cambiar el estado
		const tieneVencimiento = parseFloat(bill.type) === 1 && !bill.anulada
		if(tieneVencimiento && (bill.expiration_date === '' || bill.expiration_date === undefined || bill.expiration_date === null)){
			errores.push(this.getTrad('fillBillExpirationDate'))
		}
		if(errores.length > 0){
			this.props.setModalContent({
				title: 'Debe completar los datos obligatorios',
				body: errores,
				buttons: [{shown: 'Aceptar', behaviour: 'main', close: true}]
			});
			$("#exampleModal").modal('toggle');
			return;
		}

		const params = { status: bill.status }
		if(tieneVencimiento){
			params.expiration_date = this.adjustDateToTimezone(bill.expiration_date, false, true)
		}

		this._saving = true;
		this.setState({ isSaving: true })
		const api = this.getApi();
		api.updateBillEstadoVencimiento(bill._id, params, this.saveEstadoVencimientoCallback);
	}

	saveEstadoVencimientoCallback(response){
		this._saving = false;
		this.setState({ isSaving: false })
		if (response && response.status === 'OK') {
			this.props.setModalContent({
				title: this.getTrad('messageFromServer'),
				body: ['El estado y la fecha de vencimiento se han actualizado correctamente.'],
				buttons: [{shown: 'Aceptar', behaviour: 'main', close: true, callback: this.goBack}]
			});
		} else {
			this.props.setModalContent({
				title: 'No se han podido guardar los cambios',
				body: [response?.message || 'Error desconocido'],
				buttons: [{shown: 'Aceptar', behaviour: 'main', close: true}]
			});
		}
		$("#exampleModal").modal('toggle');
	}

    saveButton(){
		if (this._saving) return;
		this._saving = true;

		let failedValidators = {};
		const bill = this.state.bill

		if(bill.type === '' || bill.type === undefined){
			failedValidators.type = this.getTrad('fillBillType');
		}

		if(bill.client === '' || bill.client === undefined){
			failedValidators.client = this.getTrad('fillBillClient');
		}

		if(parseFloat(bill.type) === 1 && (bill.expiration_date === '' || bill.expiration_date === undefined)){
			failedValidators.expiration_date = this.getTrad('fillBillExpirationDate');
		}

		if(parseFloat(bill.type) === 2 && (bill.return_pay_bill === '' || bill.return_pay_bill === undefined)){
			failedValidators.return_pay_bill = this.getTrad('fillBillReturnPayBill');
		}

		if(bill.status === '0' || bill.status === undefined){
			failedValidators.status = this.getTrad('fillBillStatus');
		}

		if(bill.lines === undefined || bill.lines.length === 0){
			failedValidators.lines = this.getTrad('addAlmostOneLineToBill');
		}else{
			const errorsInLines = this.validateBillLines(bill.lines)
			if(errorsInLines.length > 0){
				errorsInLines.forEach((line, idx) => {
					let msgFields = ''
					for(const attr of line){
						msgFields += msgFields !== ''? ', '+this.getTrad(attr+'ErrorsInBillLine'):this.getTrad(attr+'ErrorsInBillLine')
					}
					failedValidators['line_'+idx] = this.getTrad('ErrorsInBillLine')+' '+(idx+1)+': '+msgFields
				})
			}
		}

		// Validar que cada línea con impuesto "SELECCIONAR" tiene código seleccionado
		if (this.state.taxes && bill.lines && bill.lines.length > 0) {
			bill.lines.forEach((line, idx) => {
				const tax = this.state.taxes.find(t => t._id === line.tax_type);
				if (tax && tax.verifactu_exencion_code === 'SELECCIONAR' && !line.verifactu_exencion_code) {
					failedValidators['verifactu_exencion_' + idx] =
						`Línea ${idx + 1}: debes seleccionar el código de exención Verifactu para "${tax.name}"`;
				}
			});
		}

		if(Object.keys(failedValidators).length !== 0){
			this._saving = false;
			let message = [];
			for (let m in failedValidators){
				message.push(failedValidators[m]);
			}
			this.props.setModalContent({
				title: 'Debe completar los datos obligatorios',
				body: message,
				buttons: [
					{shown: 'Aceptar', behaviour: 'main', close: true }
				]
			});

			$("#exampleModal").modal('toggle');
			return;
		}
		
		let billToSend = JSON.parse(JSON.stringify(this.state.bill))

		billToSend.tax_values = JSON.stringify(this.state.bill.tax_values || [])
		billToSend.lines = JSON.stringify(this.state.bill.lines)

		if (parseFloat(this.state.bill.type) === 1){
			billToSend.expiration_date = this.adjustDateToTimezone(this.state.bill.expiration_date)
		
			const bookings = this.state.bookings === undefined?[]:JSON.parse(JSON.stringify(this.state.bookings))
			let bookingsToSend = bookings.map(booking => {
				if(booking) delete booking._id
				return booking
			})
			billToSend.bookings = JSON.stringify(bookingsToSend)
		}else{
			delete billToSend.expiration_date
		}

		if(this.state.action === 'duplicate'){
			delete billToSend._id
			delete billToSend.created_by_user
			delete billToSend.code
			delete billToSend.modification_date
			delete billToSend.modified_by_user
		}

		this.setState({ isSaving: true })
		const api = this.getApi();
		if(this.state.action === 'modify'){
				api.updateBill(billToSend,this.updateBillCallback);
		}else{
				api.newBill(billToSend,this.newBillCallback);
		}
    }

	validateBillLines(lines){
		let errors = []
		const mandatoryFields = ['operation', 'unity_price', 'quantity', 'tax_type', 'description']
		//base_discount, line_total_price, quantity, unity_price, article, operation, base_price, tax_type, tax_price, 
		
		lines.forEach((line, index) => {
			for(const attr of mandatoryFields){
				if(line[attr] === undefined || line[attr] === null || line[attr] === '0' || line[attr] === ''){
					//Agregar error especifico para el campo undefined o null
					if(errors[index] === undefined) errors[index] = []
					errors[index].push(attr)
				}
			}

			//Comprobamos que las reservas esten completas y correctas
			if(this.state.bill.lines[index] !== undefined && this.state.bill.lines[index].article !== undefined &&
				(this.state.bookings[index] === undefined || this.state.bookings[index].article === undefined) 
			){
				if(errors[index] === undefined){
					errors[index] = []
				}
				errors[index].push('booking')
			}

		})

		return errors
	}

    updateBillCallback(response){
		this._saving = false;
		this.setState({ isSaving: false })
	    if(response.status === 'OK'){
		    this.props.setModalContent({
			    title: this.getTrad('messageFromServer'),
			    body: ['El albarán ha sido modificado satisfactoriamente.'],
			    buttons: [
			    {shown: 'Aceptar', behaviour: 'main', close: true, callback: this.goBack}
			    ]
		    });

		    $("#exampleModal").modal('toggle');
	    }else{
		    this.props.setModalContent({
			    title: this.getTrad('messageFromServer'),
			    body: [this.getTrad(response.message)],
			    buttons: [
			    {shown: 'Aceptar', behaviour: 'main', close: true}
			    ]
		    });

		    $("#exampleModal").modal('toggle');
	    }
    }

    newBillCallback(response){
		if(response.status !== 'OK'){
			this._saving = false;
			this.setState({ isSaving: false })

			this.props.setModalContent({
				title: this.getTrad('messageFromServer'),
				body: [this.getTrad(response.message)],
				buttons: [
					{shown: 'Aceptar', behaviour: 'main', close: true}
				]
			});

			$("#exampleModal").modal('toggle');
		}else{
			this._saving = false;
			this.goBack();
		}
    }

    handleChange(event) {
		let billMod = this.state.bill?{...this.state.bill}:{};

		if(event.target === undefined){
			if(event.element && event.element.name === 'expiration_date'){
				billMod[event.element.name] = event.value;
			}

			this.setState(prevState => {
				return {
				...prevState,
				bill: billMod
			}});
		}else if(event.target.name.match(/^allowedTaxes_/)){
			const parts = event.target.name.split('_');
			billMod.allowed_taxes = billMod.allowed_taxes.filter((v, i, a) => a.indexOf(v) === i);
			if(event.target.checked){
				billMod.allowed_taxes.push(parts[1]);
			}else{
				billMod.allowed_taxes = billMod.allowed_taxes.filter(tax => tax !== parts[1]);
			}

			this.setState(prevState => {
				return {
				...prevState,
				bill: billMod
			}});
		}else if(event.target.name.match(/operation$/)){
			let nameParts = event.target.name.split("_")
			billMod.lines[nameParts[0]].operation = event.target.value !== '0'?event.target.value: undefined
			
			const operation = this.state.operations.filter(op => op._id === event.target.value)[0]
			
			let newTaxesForLines = this.state.taxesForLines?JSON.parse(JSON.stringify(this.state.taxesForLines)):[]
			newTaxesForLines[nameParts[0]] = operation !== undefined?this.state.taxes.filter(tx => operation.allowed_taxes.includes(tx._id)): this.state.taxes

			this.setState(prevState => {
				return {
					...prevState,
					taxesForLines: newTaxesForLines
				}
			}, this.recalculateLine(nameParts[0], billMod.lines[nameParts[0]]))
		}else if(event.target.name.match(/quantity$/)){
			let nameParts = event.target.name.split("_")
			const parsedQty = parseFloat(event.target.value)
			billMod.lines[nameParts[0]].quantity = isNaN(parsedQty) ? undefined : parsedQty
			this.recalculateLine(nameParts[0], billMod.lines[nameParts[0]])
		}else if(event.target.name.match(/base_discount$/)){
			event.target.value = event.target.value.replace(/[a-zA-Z€]/g, '')
			event.target.value = event.target.value.replace(/[,]/g, '.')

			let nameParts = event.target.name.split("_")
			const parsedDiscount = parseFloat(event.target.value)
			billMod.lines[nameParts[0]].base_discount = isNaN(parsedDiscount) ? undefined : parsedDiscount
			this.recalculateLine(nameParts[0], billMod.lines[nameParts[0]])
		}else if(event.target.name.match(/unity_price$/)){
			event.target.value = event.target.value.replace(/[a-zA-Z€]/g, '')
			event.target.value = event.target.value.replace(/[,]/g, '.')
			let nameParts = event.target.name.split("_")
			const parsedPrice = parseFloat(event.target.value)
			billMod.lines[nameParts[0]].unity_price = isNaN(parsedPrice) ? undefined : parsedPrice
			this.recalculateLine(nameParts[0], billMod.lines[nameParts[0]])
		}else if(event.target.name.match(/verifactu_exencion_code$/)){
			const lineIdx = event.target.name.replace('_verifactu_exencion_code', '');
			billMod.lines[lineIdx].verifactu_exencion_code = event.target.value || null;
			this.setState(prevState => ({ ...prevState, bill: billMod }), () => this.recalculateBillPrices());
			return;
		}else if(event.target.name.match(/tax_type$/)){
			let nameParts = event.target.name.split("_")
			billMod.lines[nameParts[0]].tax_type = event.target.value
			// Auto-assign fixed exemption code, or clear it
			const selectedTax = this.state.taxes ? this.state.taxes.find(t => t._id === event.target.value) : null;
			if (selectedTax && selectedTax.verifactu_exencion_code && selectedTax.verifactu_exencion_code !== 'SELECCIONAR') {
				billMod.lines[nameParts[0]].verifactu_exencion_code = selectedTax.verifactu_exencion_code;
			} else {
				billMod.lines[nameParts[0]].verifactu_exencion_code = null;
			}
			this.recalculateLine(nameParts[0], billMod.lines[nameParts[0]])
		}else if(event.target.name.match(/description$/)){
			let nameParts = event.target.name.split("_")
			billMod.lines[nameParts[0]].description = event.target.value
			this.recalculateLine(nameParts[0], billMod.lines[nameParts[0]])
		}else{
			billMod[event.target.name] = typeof event.target.value === 'object'?{...event.target.value}:event.target.value;
			
			this.setState(prevState => {
				return {
				...prevState,
				bill: billMod
			}});
		}
    }

	recalculateLine(lineNumber, line){
		let taxType
		if(line.tax_type !== undefined){
			taxType = line.tax_type
		}
		if(line.operation !== undefined){
			const operation = this.state.operations.filter(op => op._id === line.operation)[0]
			if(taxType !== undefined){
				taxType = operation.allowed_taxes.includes(taxType)?taxType:operation.default_tax;
			}else{
				taxType = operation.default_tax;
			}
		}


		if(taxType !== undefined){
			line.tax_type = taxType
			const tax = this.state.taxes.filter(tx => tx._id === taxType)[0]

			$('#'+lineNumber+'_tax_type').val(taxType)

			if(line.quantity !== undefined && line.unity_price !== undefined){
				let basePrice = line.quantity*line.unity_price
				basePrice = line.base_discount !== undefined? basePrice - line.base_discount:basePrice
				line.base_price = basePrice
				line.tax_price = tax!== undefined?basePrice*(tax.value/100):0
				$('#'+lineNumber+'_tax_price').val(line.tax_price+"€")

				line.line_total_price = basePrice + line.tax_price
				$('#'+lineNumber+'_line_total_price').val(line.line_total_price+"€")
			}
		}

		this.recalculateBillPrices()
	}

	recalculateBillPrices(){
		let totalBasePrice = 0
		let totalBaseDiscount = 0
		let totalTaxes = 0

		let newBill = JSON.parse(JSON.stringify(this.state.bill));

		//Bucle general para conceptos no relacionados con impuestos
		this.state.bill.lines.forEach(line => {
			totalBasePrice += line.base_price !== undefined?line.base_price: 0
			totalBaseDiscount += line.base_discount !== undefined? line.base_discount: 0
		})

		//Solo para impuestos — agrupado por (tax_type + verifactu_exencion_code)
		const taxGroups = {};
		this.state.bill.lines.forEach(line => {
			const tax = this.state.taxes ? this.state.taxes.find(t => t._id === line.tax_type) : null;
			if (!tax) return;
			const exencionCode = tax.verifactu_exencion_code && tax.verifactu_exencion_code !== 'SELECCIONAR'
				? tax.verifactu_exencion_code
				: (line.verifactu_exencion_code || null);
			const key = line.tax_type + '|' + (exencionCode || '');
			if (!taxGroups[key]) {
				taxGroups[key] = { name: tax.name, tax_type: tax._id, total_base: 0, total_tax: 0, verifactu_exencion_code: exencionCode };
			}
			taxGroups[key].total_base += line.base_price !== undefined ? line.base_price : 0;
			taxGroups[key].total_tax += line.tax_price !== undefined ? line.tax_price : 0;
			totalTaxes += line.tax_price !== undefined ? line.tax_price : 0;
		});
		newBill.tax_values = Object.values(taxGroups).filter(g => g.total_base !== 0);

		newBill.base_price = totalBasePrice;
		newBill.discount = totalBaseDiscount;
		newBill.total_price = totalBasePrice + totalTaxes;

		// Si el total ya no cumple el umbral de simplificada, desmarcar automáticamente
		if (newBill.simplificada && parseFloat(newBill.total_price || 0) >= 400) {
			newBill.simplificada = false;
		}

		this.setState(prevState => {
			return {
				...prevState,
				bill: newBill
			}
		});
	}

	addClient(e){
		$("#client-selector-component").modal('toggle');
    }

	addArticle(e){
		const nameParts = e.target.name.split("_")
		const lineNumber = nameParts[0]
		this.setState(prevState => {
			return {
				...prevState,
				lineToModify: lineNumber
			}
		});

		const article = this.state.bill.lines[lineNumber].article
		const bookings = this.state.bookings?.filter(book => String(book.article) === String(article))

		const selectedBooking = {
			article: article,
			bookings: bookings,
			billCode: this.state.bill.code?this.state.bill.code:undefined,
			showAllArticles: parseFloat(this.state.bill.type) === 2? true: false
		}

		this.articleSel.current.setSelectedBooking(selectedBooking)

		$("#article-selector-component").modal('toggle')
    }

	clientSelectedCallback(clientSelected){
    	this.clientInputValue = clientSelected!== null?clientSelected.clients[0]:null;
    	this.deletedClient = this.clientInputValue === null?true:false;
    	this.clientInput.current.value = clientSelected!== null && this.clientInputValue?this.clientInputValue.name+' '+this.clientInputValue.lastname:'';
	
		if(clientSelected === null || clientSelected.clients[0] === null) clientSelected = undefined;

		let newBill = this.state.bill !== undefined? JSON.parse(JSON.stringify(this.state.bill)) : {}
		newBill.client = clientSelected !== undefined? clientSelected.clients[0]._id:undefined

		this.setState(prevState => {
			return {
				...prevState,
				selectedClient: clientSelected?clientSelected.clients[0]:undefined,
				bill: newBill
			}
		});
	}

	articleSelectedCallback(articleSelected){

    	this.articleInputValue = articleSelected.article!== null?articleSelected.article:null;
    	this.deletedArticle = this.articleInputValue === null?true:false;
		if(articleSelected === null || articleSelected.article === null) articleSelected = undefined;

		let newBill = JSON.parse(JSON.stringify(this.state.bill))
		newBill.lines[this.state.lineToModify].completeArticle = articleSelected !== undefined?articleSelected.article:''

		let newBookings = this.state.bookings?JSON.parse(JSON.stringify(this.state.bookings)):[]

		newBookings[this.state.lineToModify] = articleSelected?.article !== undefined?{
			article : articleSelected.article?._id,
			booking_status: parseFloat(articleSelected.status),
			start_date: this.adjustDateToTimezone(articleSelected.start_date, false, true),
			end_date: this.adjustDateToTimezone(articleSelected.end_date, false, true)
		}:{};

		this.setState(prevState => {
			return {
				...prevState,
				selectedArticle: articleSelected?articleSelected:undefined,
				lineToModify: undefined,
				bill: newBill,
				bookings: newBookings
			}
		});
	}

	billSelectedCallback(selectedBill){
		let newBill = this.state.bill !== undefined ? JSON.parse(JSON.stringify(this.state.bill)) : {};
		newBill.return_pay_bill = selectedBill.code || selectedBill._id;
		if (selectedBill.lines && selectedBill.lines.length > 0) {
			newBill.lines = selectedBill.lines.map(line => {
				const neg = JSON.parse(JSON.stringify(line));
				delete neg._id;
				if (neg.unity_price != null) neg.unity_price = -(parseFloat(neg.unity_price) || 0);
				if (neg.base_price != null) neg.base_price = -(parseFloat(neg.base_price) || 0);
				if (neg.tax_price != null) neg.tax_price = -(parseFloat(neg.tax_price) || 0);
				if (neg.line_total_price != null) neg.line_total_price = -(parseFloat(neg.line_total_price) || 0);
				if (neg.base_discount != null) neg.base_discount = -(parseFloat(neg.base_discount) || 0);
				return neg;
			});
		}
		newBill.base_price = selectedBill.base_price != null ? -parseFloat(selectedBill.base_price) : newBill.base_price;
		newBill.total_price = selectedBill.total_price != null ? -parseFloat(selectedBill.total_price) : newBill.total_price;

		// Propagar el cliente de la factura original
		const client = selectedBill.client && typeof selectedBill.client === 'object' ? selectedBill.client : null;
		if (client) {
			newBill.client = client._id;
			this.clientInputValue = client;
			if (this.clientInput.current) {
				this.clientInput.current.value = [client.name, client.lastname].filter(Boolean).join(' ');
			}
		}

		this.setState(prevState => ({
			...prevState,
			bill: newBill,
			selectedReturnBill: selectedBill,
			selectedClient: client || prevState.selectedClient
		}), this.recalculateBillPrices);
	}

	addLine(){
		let newBill = this.state.bill !== undefined? JSON.parse(JSON.stringify(this.state.bill)) : {}
		if(newBill.lines !== undefined){
			newBill.lines.push({quantity:1})
		}else{
			newBill.lines = [{quantity:1}]
		}
		this.setState(prevState => {
			return {
				...prevState,
				bill: newBill
			}
		})
	}

	dropLine(e){
		let newBill = this.state.bill !== undefined? JSON.parse(JSON.stringify(this.state.bill)) : {}
		let nameParts = e.target.name.split("_")

		newBill.lines = this.state.bill.lines.filter((line,idx) => parseInt(idx) !== parseInt(nameParts[0]));
		
		this.setState(prevState => {
			return {
				...prevState,
				bill: newBill
			}
		}, this.recalculateBillPrices.bind(this))
		
	}

	generateRLKey(line, rlkey){
		let finalString = '';
		for(let key in line){
			finalString += line[key] + '_';
		}
		return finalString + rlkey;
	}

	renderLine(line, rlkey){

		let lineFromState = this.state.bill && this.state.bill.lines !== undefined && this.state.bill.lines[rlkey] !== undefined? this.state.bill.lines[rlkey]:{}
		lineFromState.article = lineFromState.completeArticle !== undefined?lineFromState.completeArticle._id:undefined

		return (
			<div key={'rl_card_'+this.generateRLKey(line, rlkey)} className="card mb-2" style={{border:'1px solid #dee2e6'}}>
				<div className="card-header py-2 d-flex align-items-center" style={{background:'#f8f9fa'}}>
					<span className="text-muted small font-weight-bold mr-auto">Línea {rlkey + 1}</span>
					<button type="button" className="btn btn-sm btn-outline-danger"
						name={rlkey+"_drop_line"} id={rlkey+"_drop_line"} onClick={this.dropLine}>
						Eliminar
					</button>
				</div>
				<div className="card-body py-3">
					<div className="form-row mb-2">
						<div className="col-md-3">
							<label className="small text-muted mb-1">{this.getTrad('Operation')}</label>
							<select className="form-control form-control-sm" id={rlkey+'_operation'} name={rlkey+'_operation'}
								defaultValue={lineFromState?lineFromState.operation:''} onChange={this.handleChange}>
								<option value="0">{this.getTrad("selectAnOption")}</option>
								{this.state.operations?this.state.operations.map(op => {
									return <option key={'rl_op_'+op._id} value={op._id}>{op.name}</option>
								}):undefined}
							</select>
						</div>
						<div className="col-md-4">
							<label className="small text-muted mb-1">{this.getTrad('Article')}</label>
							<div className="input-group input-group-sm">
								<input ref={this.articleInput} id={rlkey+'_article'} type="text" name={rlkey+'_article'}
									readOnly className="form-control"
									style={{cursor: parseFloat(this.state.bill?.type) !== 2 ? 'pointer' : 'default'}}
									value={lineFromState && lineFromState.completeArticle?lineFromState.completeArticle.name:''}
									onClick={parseFloat(this.state.bill?.type) !== 2 ? this.addArticle : undefined}/>
								{parseFloat(this.state.bill?.type) !== 2 ?
									<div className="input-group-append">
										<button type="button" className="btn btn-outline-primary"
											id={rlkey+'_add_article'} name={rlkey+'_add_article'}
											onClick={this.addArticle}>
											{lineFromState.completeArticle && lineFromState.completeArticle !== ''?this.getTrad('modify'):this.getTrad('addArticle')}
										</button>
									</div>
								:null}
							</div>
						</div>
						<div className="col-md-2">
							<label className="small text-muted mb-1">{this.getTrad('Quantity')}</label>
							<input type='number' className="form-control form-control-sm text-right"
								id={rlkey+'_quantity'} name={rlkey+'_quantity'}
								defaultValue={lineFromState && lineFromState.quantity != null && !isNaN(lineFromState.quantity)?lineFromState.quantity:1} onBlur={this.handleChange} />
						</div>
						<div className="col-md-3">
							<label className="small text-muted mb-1">{this.getTrad('UnityPrice')}</label>
							<input type='text' className="form-control form-control-sm text-right"
								id={rlkey+'_unity_price'} name={rlkey+'_unity_price'}
								defaultValue={lineFromState && lineFromState.unity_price != null && !isNaN(lineFromState.unity_price)?lineFromState.unity_price+"€":''} onBlur={this.handleChange} />
						</div>
					</div>
					<div className="form-row mb-2">
						<div className="col-md-3">
							<label className="small text-muted mb-1">{this.getTrad('BaseDiscount')}</label>
							<input type='text' className="form-control form-control-sm text-right"
								id={rlkey+'_base_discount'} name={rlkey+'_base_discount'}
								defaultValue={lineFromState && lineFromState.base_discount != null && !isNaN(lineFromState.base_discount)?lineFromState.base_discount+"€":''} onBlur={this.handleChange} />
						</div>
						<div className="col-md-3">
							<label className="small text-muted mb-1">{this.getTrad('TaxType')}</label>
							<select className="form-control form-control-sm" id={rlkey+'_tax_type'} name={rlkey+'_tax_type'}
								onChange={this.handleChange} defaultValue={lineFromState?lineFromState.tax_type:''}>
								<option value="0">{this.getTrad("selectAnOption")}</option>
								{this.state.taxesForLines && this.state.taxesForLines[rlkey]?this.state.taxesForLines[rlkey].map((tax,idx) => {
									return <option value={tax._id} key={'tax_'+rlkey+'_'+idx}>{tax.name}</option>
								}):this.state.taxes?this.state.taxes.map((tax,idx) => {
									return <option value={tax._id} key={'tax_'+rlkey+'_'+idx}>{tax.name}</option>
								}):''}
							</select>
						</div>
						{(() => {
							const selectedTax = this.state.taxes && lineFromState.tax_type
								? this.state.taxes.find(t => t._id === lineFromState.tax_type)
								: null;
							if (!selectedTax || selectedTax.verifactu_exencion_code !== 'SELECCIONAR') return null;
							return (
								<div className="col-md-3">
									<label className="small text-muted mb-1">Exención Verifactu <span className="text-danger">*</span></label>
									<select className="form-control form-control-sm"
										id={rlkey+'_verifactu_exencion_code'}
										name={rlkey+'_verifactu_exencion_code'}
										onChange={this.handleChange}
										value={lineFromState.verifactu_exencion_code || ''}>
										<option value="">— Seleccionar motivo —</option>
										<option value="E1">E1 — Art. 20 LIVA (enseñanza, salud, financieras...)</option>
										<option value="E2">E2 — Art. 21 LIVA (exportaciones)</option>
										<option value="E3">E3 — Art. 22 LIVA (asimiladas a exportaciones)</option>
										<option value="E4">E4 — Art. 23-24 LIVA (regímenes diplomáticos)</option>
										<option value="E5">E5 — Art. 25 LIVA (Canarias, Ceuta, Melilla)</option>
										<option value="E6">E6 — Art. 26 LIVA (otras exenciones)</option>
										<option value="E7">E7 / N1 — No sujeta Art. 7, 14 LIVA (→ CalificacionOperacion N1)</option>
										<option value="E8">E8 / N2 — No sujeta por reglas de localización (→ CalificacionOperacion N2)</option>
									</select>
								</div>
							);
						})()}
						<div className="col-md-3">
							<label className="small text-muted mb-1">{this.getTrad('TaxPrice')}</label>
							<input readOnly type='text' className="form-control form-control-sm text-right"
								id={rlkey+'_tax_price'} name={rlkey+'_tax_price'}
								value={lineFromState && lineFromState.tax_price!== undefined?this.roundValues(lineFromState.tax_price)+"€":''} />
						</div>
						<div className="col-md-3">
							<label className="small text-muted mb-1">{this.getTrad('LineTotalPrice')}</label>
							<input readOnly type='text' className="form-control form-control-sm text-right"
								id={rlkey+'_line_total_price'} name={rlkey+'_line_total_price'}
								value={lineFromState && lineFromState.line_total_price!== undefined?this.roundValues(lineFromState.line_total_price)+"€":''} />
						</div>
					</div>
					<div className="form-row">
						<div className="col-12">
							<label className="small text-muted mb-1">{this.getTrad('LineDescription')}</label>
							<input type='text' className="form-control form-control-sm"
								id={rlkey+'_line_description'} name={rlkey+'_line_description'} onBlur={this.handleChange}
								defaultValue={lineFromState && lineFromState.description?lineFromState.description:''} />
						</div>
					</div>
				</div>
			</div>
		)

	}

	renderBillLines(){

		return (
			<>
				<div className="mb-2">
					{this.state.bill && this.state.bill.lines?this.state.bill.lines.map((line, idx) => {
						return this.renderLine(line, idx);
					}):this.renderLine(undefined, 0)}
				</div>
				<button type="button" className="btn btn-sm btn-outline-primary"
					name="add_line" id="add_line" onClick={this.addLine}>
					+ Añadir línea
				</button>
			</>
		)
	}

	renderTaxValues(){

		return (
			<>
			{this.state.bill && this.state.bill.tax_values.length>0?this.state.bill.tax_values.map((tval, tvidx) => {
				if (tval === undefined || tval === null) return '';
				const exencionLabel = tval.verifactu_exencion_code ? ` (${tval.verifactu_exencion_code})` : '';
				return (
					<div key={'taxes_'+tvidx} style={{borderBottom:'1px solid #e9ecef'}}>
						<div className="d-flex justify-content-between py-1">
							<span className="text-muted small">{tval.name}{exencionLabel}</span>
							<div className="small">
								<span className="mr-3 text-muted">Base: <strong>{this.roundValues(tval.total_base)}€</strong></span>
								<span className="text-muted">IVA: <strong>{this.roundValues(tval.total_tax)}€</strong></span>
							</div>
						</div>
					</div>
				);
			}):''}
			</>
		)
	}

	displayBillHeader(){
		return (
			<>
			<div className='row'>
				<div className='col-6' style={{marginTop:'20px'}}>
					<span style={{fontSize: '50px', marginLeft:'30px'}}>
						<img alt="Logo" src={logo} width="250" />
					</span>
				</div>
				<div className='col-6 text-right'>
					<div style={{width:'100%', paddingRight:'30px'}}>
						<h2 style={{color: '#b9d9fd'}}>{this.state.bill && parseFloat(this.state.bill.type) === 1?
							'Factura de venta':'Factura rectificativa'}</h2>
						<div style={{display:'block', paddingRight:'15px'}} className='row text-right'>
							<span className='font-weight-bold'>Fecha de albarán</span> 
							{this.state.bill?' '+this.convertToPdfDate(this.state.bill.creation_date):''}
							</div>
						{this.state.bill && this.state.bill.expiration_date !== undefined?
						<div style={{display:'block', paddingRight:'15px'}} className='row text-right'>
							<span className='font-weight-bold'>Plazo</span> 
							{this.state.bill?' '+this.convertToPdfDate(this.state.bill.expiration_date):''}
						</div>:''}
						{this.state.selectedClient?.dni?
						<div style={{display:'block', paddingRight:'15px'}} className='row text-right'>
							<span className='font-weight-bold' style={{marginRight: '8px'}}>Su Nif</span> 
							{this.state.selectedClient.dni}
						</div>:''}
						<div style={{display:'block', paddingRight:'15px'}} className='row text-right'>
							<span className='font-weight-bold'>{this.getTrad('billCode')}</span> {this.state.bill?this.state.bill.code:''}
						</div>
					</div>
				</div>
			</div>
			<div className='row'>
				<div className='col-5'>
					<div style={{marginLeft:'30px', lineHeight:'1'}}>
						<h2 style={{marginLeft:'15px'}}>ACCEDIENDO SLU</h2>
						<div style={{marginLeft:'15px', lineHeight:'1'}} className='row'>CERRO DE VALDECAHONDE 6, 2ºD</div>
						<div style={{marginLeft:'15px'}} className='row'>MADRID, 28023</div>
						<div style={{marginLeft:'15px'}} className='row'>Spain</div>
						<div style={{marginLeft:'15px', marginTop:'10px'}} className='row'>NIF ES B87258125</div>
						<div style={{marginLeft:'15px', marginTop:'10px'}} className='row'>www.accedan.com</div>
						<div style={{marginLeft:'15px'}} className='row'>608583106</div>
						<div style={{marginLeft:'15px'}} className='row'>910 532 374</div>
						<div style={{marginLeft:'15px'}} className='row'>INFO@ACCEDAN.COM</div>
					</div>
				</div>
				<div className='col-6'>
							<div style={{marginTop:'50px'}} className='row'>
								{this.state.selectedClient?this.state.selectedClient.name+' '+this.state.selectedClient.lastname:''}
							</div>
							<div className='row'>
								{this.state.selectedClient?this.state.selectedClient.complete_direction:''}
							</div>
				</div>
			</div>
			</>				
		)
	}

	displayBillBody(){
		return (
			<>
			<div className='row'>
				<div className='col-12'>
					<table className='table' style={{marginLeft:'30px', marginTop: '50px', width:'95%'}}>
						<thead  className='font-weight-bold'>
							<tr>
								<th style={{width:'50%', borderTop:'0px', borderBottom:'1px solid #b9d9fd'}}>{this.getTrad('LineDescription')}</th>
								<th className='text-right' style={{width:'10%', borderTop:'0px', borderBottom:'1px solid #b9d9fd'}}>{this.getTrad('Cant./Horas')}</th>
								<th className='text-right' style={{width:'15%', borderTop:'0px', borderBottom:'1px solid #b9d9fd'}}>{this.getTrad('Precio/unidad')}</th>
								<th className='text-center' style={{width:'10%', borderTop:'0px', borderBottom:'1px solid #b9d9fd'}}>{this.getTrad('IVA %')}</th>
								<th className='text-right' style={{width:'15%', borderTop:'0px', borderBottom:'1px solid #b9d9fd'}}>{this.getTrad('Base imponible')}</th>
							</tr>
						</thead>
						<tbody>
							{this.state.bill?this.state.bill.lines.map((line,idx) => {
								const tax = (this.state.taxes||[]).filter(tax => tax._id === line.tax_type)
								return (<tr key={'pdf_line_'+idx}>
										<td>{line.description}</td>
										<td className='text-right'>{parseFloat(line.quantity).toFixed(2)}</td>
										<td className='text-right'>{parseFloat(line.unity_price).toFixed(2)}</td>
										<td className='text-center'>{tax[0]!== undefined?parseFloat(tax[0].value).toFixed(2):''}</td>
										<td className='text-right'>{parseFloat(line.base_price).toFixed(2)}</td>
									</tr>
								)
							}):undefined}

						</tbody>
					</table>
				</div>
			</div>
			<div className='row mt-5'>
				<div className='col-5'>
					<div style={{marginLeft:'60px'}}>
						<div className='row font-weight-bold' style={{fontSize:'20px'}}>{this.getTrad('billLegalText1')}</div>
						<div className='row'>{this.getTrad('billLegalText2')}</div>
						<div className='row'>{this.getTrad('billLegalText3')}</div>
						<div className='row'>{this.getTrad('billLegalText4')}</div>
						<div className='row'>{this.getTrad('billLegalText4.1')}</div>
						<div className='row font-weight-bold mt-3' style={{fontSize:'20px'}}>{this.getTrad('billLegalText5')}</div>
						<div className='row'>{this.getTrad('billLegalText6')}</div>
						<div className='row'>{this.getTrad('billLegalText7')}</div>
					</div>
				</div>
				<div className='col-7'>
					<table className='table' style={{marginLeft:'100px', width:'80%'}}>
						<thead>
							<tr>
								<th className='text-right' style={{width:'50%', borderTop:'0px', borderBottom:'1px solid #b9d9fd'}}>Base imponible</th>
								<th className='text-right' style={{width:'50%', borderTop:'0px', borderBottom:'1px solid #b9d9fd'}}>Tipo de IVA</th>
								<th className='text-right' style={{width:'50%', borderTop:'0px', borderBottom:'1px solid #b9d9fd'}}>Total</th>
							</tr>
						</thead>
						<tbody>
							{this.state.bill && this.state.bill.tax_values?this.state.bill.tax_values.map((taxLine,idx) => {
								
								return (<tr key={'pdf_tax_values'+idx}>
									<td className='text-right'>{parseFloat(taxLine.total_base).toFixed(2)}</td>
									<td className='text-right'>{taxLine.name}</td>
									<td className='text-right'>{parseFloat(taxLine.total_tax).toFixed(2)}</td>
								</tr>)
							}):undefined}
						</tbody>
					</table>
					<div className='row font-weight-bold text-right' style={{backgroundColor: '#b9d9fd', marginLeft:'100px', width: '80%', lineHeight:'5'}}>
						<div className='col-7'>
							Total
						</div>
						<div className='col-5'>{this.state.bill?parseFloat(this.state.bill.total_price).toFixed(2)+'€':''}</div>
					</div>
				</div>
			</div>
			{(this.state.bill?.verifactu_status === 'Correcto' || this.state.bill?.verifactu_status === 'ParcialmenteCorrecto') ? (
				<div className='row mt-5' style={{marginLeft:'30px'}}>
					<div className='col-12 d-flex align-items-center' style={{gap:'20px'}}>
						<QRCode
							value={`${(process.env.REACT_APP_AEAT_ENTORNO || 'test') === 'test' ? 'https://prewww2.aeat.es' : 'https://www2.agenciatributaria.gob.es'}/wlpl/TIKE-CONT/ValidarQR?nif=${encodeURIComponent('B87258125')}&numserie=${encodeURIComponent(this.state.bill.code)}&fecha=${encodeURIComponent(this.convertToPdfDate(this.state.bill.creation_date).replace(/\//g,'-'))}&importe=${encodeURIComponent(parseFloat(this.state.bill.total_price).toFixed(2))}`}
							size={90}
						/>
						<span style={{fontSize:'11px', color:'#555', maxWidth:'200px', lineHeight:'1.4'}}>
							Factura verificable en la sede electrónica de la AEAT
						</span>
					</div>
				</div>
			) : null}
			</>
		)
	}

    render(){
		
        return (
			<>
			{/*<button onClick={() => {this.verState()}}>Ver state</button>*/}
            <div className="container">
            	<Menu />
                <h3 className="mb-4">{this.state.action === 'new'?this.getTrad('billInsertion'):this.getTrad('billEdition')}</h3>
                <div className="row">
			<div className="col-12">

			{(this.state.bill || this.state.action === 'new')?
				<>
				  {this.state.bill && this.state.bill.anulada ? (
					<div className="alert alert-danger d-flex align-items-center mb-3" role="alert">
						<strong style={{fontSize: '1.1em', letterSpacing: '0.05em'}}>FACTURA ANULADA</strong>
						<span className="ml-2">— Esta factura fue anulada ante la AEAT a través de Verifactu. Solo se puede modificar su estado.</span>
					</div>
				  ) : ''}
				  {this.esSoloLectura() && this.state.bill && !this.state.bill.anulada ? (
					<div className="alert alert-info mb-3" role="alert">
						Esta factura ya se ha enviado a Verifactu. Solo se puede modificar el estado y la fecha de vencimiento.
					</div>
				  ) : ''}
				  {/* Tipo, estado y (si existe) fecha emisión + código en una sola fila */}
				  <div className="form-row mb-3">
					<div className="col-md-3">
						<label htmlFor="type" className="small text-muted mb-1">Tipo albarán</label>
						<select className="form-control" id="type" name="type" disabled={this.esSoloLectura()}
							defaultValue={this.state.bill?this.state.bill.type:''} onChange={this.handleChange}>
							<option value="0">{this.getTrad("selectAnOption")}</option>
							<option value="1">{this.getTrad("getPaidBill")}</option>
							<option value="2">{this.getTrad("returnPayBill")}</option>
						</select>
					</div>
					<div className="col-md-3">
						<label htmlFor="status" className="small text-muted mb-1">Estado</label>
						<select className="form-control" id="status" name="status"
							defaultValue={this.state.bill?this.state.bill.status:''} onChange={this.handleChange}>
							<option value="0">{this.getTrad("selectAnOption")}</option>
							<option value="1">{this.getTrad("pendingBillStatus")}</option>
							<option value="2">{this.getTrad("overdueBillStatus")}</option>
							<option value="3">{this.getTrad("collectedBillStatus")}</option>
							<option value="4">{this.getTrad("unpaidBillStatus")}</option>
							<option value="5">{this.getTrad("returnedPayBillStatus")}</option>
						</select>
					</div>
					{this.state.bill?.creation_date?<>
						<div className="col-md-3">
							<label className="small text-muted mb-1">Fecha de emisión</label>
							<input id="creation_date" name="creation_date" className="form-control bg-light" readOnly
								value={this.convertToPdfDate(this.adjustDateToTimezone(this.state.bill.creation_date))} />
						</div>
						<div className="col-md-3">
							<label className="small text-muted mb-1">Código de albarán</label>
							<input id="code" name="code" className="form-control bg-light" readOnly
								value={this.state.bill.code} />
						</div>
					</>:''}
				  </div>

				  {/* Fecha vencimiento — solo facturas normales */}
				  {(this.state.bill && parseFloat(this.state.bill.type) === 1) || this.state.bill === undefined
				  	|| this.state.bill.type === undefined?
				  <div className="form-row mb-3">
					<div className="col-md-4">
						<label htmlFor="expiration_date" className="small text-muted mb-1">Fecha vencimiento</label>
						<DateTimePickerComponent format='dd/MM/yy hh:mm a' id="expiration_date" enabled={!this.state.bill?.anulada}
							value={this.state.bill?new Date(this.state.bill.expiration_date):undefined} change={this.handleChange} />
					</div>
				  </div>
				  :''}

				  {/* Cliente, factura rectificada y líneas: bloqueados en facturas ya enviadas */}
				  <fieldset disabled={this.esSoloLectura()} style={{border: 0, padding: 0, margin: 0, minWidth: 0}}>
				  {/* Cliente */}
				  <div className="form-group mb-3">
				    <label htmlFor="clientName" className="small text-muted mb-1">Cliente</label>
					<div className="input-group">
						<input ref={this.clientInput} id="clientName" value={this.state.selectedClient?this.state.selectedClient.name+' '+this.state.selectedClient.lastname:undefined}
							type="text" name="clientName" readOnly className="form-control" />
						<input id="client" type="hidden" name="client"/>
						<div className="input-group-append">
							<button className="btn btn-outline-primary" onClick={this.addClient}>
								{this.state.selectedClient?"Cambiar cliente":"Agregar cliente"}
							</button>
						</div>
					</div>
				  </div>

				  {/* Factura que rectifica — solo rectificativas */}
				  {this.state.bill && parseFloat(this.state.bill.type) === 2?
				  <div className="form-group mb-3">
				    <label className="small text-muted mb-1">Factura que rectifica</label>
					<div className="input-group">
						<input readOnly className="form-control"
							value={this.state.selectedReturnBill?this.state.selectedReturnBill.code:(this.state.bill?.return_pay_bill || '')}
							placeholder="Ninguna seleccionada" />
						<div className="input-group-append">
							<button type="button" className="btn btn-outline-primary"
								onClick={() => this.billSel.current && this.billSel.current.open()}>
								Seleccionar
							</button>
						</div>
					</div>
				  </div>:''}

				  {/* Líneas */}
				  <div className="mb-3">
				  	<label className="small text-muted mb-2 d-block">{this.getTrad('Lines')}</label>
					{this.renderBillLines()}
				  </div>
				  </fieldset>

				  {/* Resumen de totales */}
				  <div className="mt-3 mb-4 p-3 rounded" style={{background:'#f8f9fa', border:'1px solid #dee2e6'}}>
					{this.state.bill !== undefined && this.state.bill.tax_values !== undefined && this.state.bill.tax_values.length>0?
					this.renderTaxValues():''}
					<div className="d-flex justify-content-end align-items-center mt-2 pt-1">
						<span className="text-muted small mr-3">Base imponible</span>
						<input type="text" readOnly id="base_price" name="base_price"
							className="text-right font-weight-bold small"
							style={{border:'none', background:'transparent', width:'100px'}}
							value={this.state.bill && this.state.bill.base_price!== undefined?this.roundValues(this.state.bill.base_price)+"€":''} />
					</div>
					<div className="d-flex justify-content-end align-items-center border-top mt-1 pt-2">
						<span className="font-weight-bold mr-3">Total</span>
						<input type="text" readOnly id="total_price" name="total_price"
							className="text-right font-weight-bold"
							style={{border:'none', background:'transparent', width:'100px', fontSize:'1.1em'}}
							value={this.state.bill && this.state.bill.total_price!== undefined?this.roundValues(this.state.bill.total_price)+"€":''} />
					</div>
				  </div>

				  {/* Factura simplificada (solo ordinarias con importe < 400€) */}
				  {this.state.bill && parseFloat(this.state.bill.type) === 1 && parseFloat(this.state.bill.total_price || 0) < 400 && (
					<div className="d-flex justify-content-end align-items-center mt-2">
						<label style={{display:'flex', alignItems:'center', gap:'8px', cursor:'pointer', fontSize:'13px', color:'#374151', userSelect:'none'}}>
							<input
								type="checkbox"
								checked={this.state.bill.simplificada || false}
								onChange={e => this.setState({ bill: { ...this.state.bill, simplificada: e.target.checked } })}
								style={{width:'16px', height:'16px', cursor:'pointer'}}
							/>
							Emitir como factura simplificada (sin datos del destinatario)
						</label>
					</div>
				  )}

				  {/* Acciones */}
				  <div className="d-flex justify-content-between align-items-center mb-4">
					<div style={{display:'flex', gap:'8px'}}>
						{(this.state.action === 'new' || this.state.action === 'duplicate')?
							<button type="button" className="btn btn-primary" onClick={this.saveButton} disabled={this.state.isSaving}>
								{this.state.isSaving ? 'Guardando...' : 'Guardar'}
							</button>:''}
						{this.state.bill && this.state.bill.code !== undefined && this.state.action !== 'duplicate'?<ReactToPrint
							onBeforePrint={() => {document.title = this.state.bill && this.state.bill.code !== undefined?this.state.bill.code.replace(/\//g, '_'):"CRM Accedan"}}
							onAfterPrint={() => {document.title = "CRM Accedan"}}
							trigger={() => <button type="button" className="btn btn-outline-secondary">Imprimir</button>}
							content={() => this.componentRef}
						/>:''}
						{this.state.action === 'modify' && this.state.bill ? (
							<button type="button" className="btn btn-outline-secondary" onClick={this.saveEstadoVencimiento} disabled={this.state.isSaving}>
								{this.state.isSaving ? 'Guardando...' : (this.state.bill.anulada ? 'Guardar estado' : 'Guardar estado y vencimiento')}
							</button>
						) : ''}
						{this.state.action === 'modify' && this.state.bill ? (
							<button type="button" className="btn btn-outline-secondary" onClick={() => this.setState({verifactuModalOpen: true})}>
								Verifactu
							</button>
						) : ''}
						{this.state.action === 'modify' && this.state.bill && !this.state.bill.anulada && this.isSystemAdmin() ? (
							<button type="button" className="btn btn-danger" onClick={this.anularEnVerifactu}>
								Anular en Verifactu
							</button>
						) : ''}
					</div>
					<button type="button" className="btn btn-outline-secondary" onClick={this.cancelButton}>Cancelar</button>
				  </div>

				</>

			:<span>...</span>}

			</div>
            </div>
			
			<ClientSelector ref={this.clientSel} onClientSelected={this.clientSelectedCallback}  />
			<ArticleSelector
				ref={this.articleSel}
				onArticleSelected={this.articleSelectedCallback}
			/>
			<BillSelector
				ref={this.billSel}
				onBillSelected={this.billSelectedCallback}
				getApi={() => this.getApi()}
			/>
			<Modal />
            </div>

			{/* Modal Verifactu */}
			{this.state.verifactuModalOpen && this.state.bill ? (() => {
				const vs = this.state.bill.verifactu_status;
				const log = this.state.verifactuLog;
				const entries = log?.queue || [];
				const latest = entries[0] || null;
				const correcto = vs === 'Correcto';
				const parcialmenteCorrecto = vs === 'ParcialmenteCorrecto';
				const pendiente = latest && ['pending', 'processing', 'retrying'].includes(latest.status);
				const badgeColor = correcto ? '#28a745'
					: parcialmenteCorrecto ? '#fd7e14'
					: vs === 'Incorrecto' ? '#dc3545'
					: pendiente ? '#007bff'
					: '#6c757d';
				const badgeText = correcto ? 'Correcto'
					: parcialmenteCorrecto ? 'ParcialmenteCorrecto'
					: vs === 'Incorrecto' ? 'Incorrecto'
					: pendiente ? (latest.status === 'retrying' ? `Reintentando (${latest.attempts}/${latest.maxAttempts})` : 'En cola…')
					: 'Sin enviar';
				const qrUrl = `${(process.env.REACT_APP_AEAT_ENTORNO || 'test') === 'test' ? 'https://prewww2.aeat.es' : 'https://www2.agenciatributaria.gob.es'}/wlpl/TIKE-CONT/ValidarQR?nif=${encodeURIComponent('B87258125')}&numserie=${encodeURIComponent(this.state.bill.code)}&fecha=${encodeURIComponent(this.convertToPdfDate(this.state.bill.creation_date).replace(/\//g,'-'))}&importe=${encodeURIComponent(parseFloat(this.state.bill.total_price).toFixed(2))}`;

				const statusColor = s => s === 'done' ? '#28a745' : s === 'permanently_failed' ? '#dc3545' : s === 'pending' ? '#6c757d' : '#007bff';
				const aeatColor = s => (s === 'Correcto' || s === 'ParcialmenteCorrecto') ? '#28a745' : '#dc3545';

				return (
					<>
						{/* Backdrop */}
						<div
							onClick={() => this.setState({verifactuModalOpen: false})}
							style={{position:'fixed', inset:0, background:'rgba(0,0,0,0.5)', zIndex:1040}}
						/>
						{/* Modal */}
						<div style={{position:'fixed', top:'50%', left:'50%', transform:'translate(-50%,-50%)', zIndex:1050, background:'#fff', borderRadius:'8px', boxShadow:'0 4px 24px rgba(0,0,0,0.2)', width:'560px', maxWidth:'95vw', maxHeight:'85vh', display:'flex', flexDirection:'column'}}>
							{/* Header */}
							<div style={{padding:'16px 20px', borderBottom:'1px solid #dee2e6', display:'flex', alignItems:'center', gap:'12px'}}>
								<strong style={{fontSize:'15px', flex:1}}>Verifactu — {this.state.bill.code}</strong>
								<span style={{background:badgeColor, color:'#fff', borderRadius:'4px', padding:'2px 10px', fontSize:'12px', fontWeight:'600'}}>
									{badgeText}
								</span>
								{pendiente && <span style={{fontSize:'11px', color:'#888'}}>↻ actualizando…</span>}
								<button
									type="button"
									title="Actualizar"
									onClick={() => this.loadVerifactuLog(this.state.bill._id)}
									style={{background:'none', border:'1px solid #dee2e6', borderRadius:'4px', fontSize:'13px', cursor:'pointer', color:'#555', padding:'2px 8px', lineHeight:'1.4'}}
								>↻</button>
								<button
									type="button"
									onClick={() => this.setState({verifactuModalOpen: false})}
									style={{background:'none', border:'none', fontSize:'20px', cursor:'pointer', color:'#666', lineHeight:1, padding:'0 4px'}}
								>×</button>
							</div>
							{/* Body */}
							<div style={{padding:'20px', overflowY:'auto', flex:1}}>

								{/* QR si correcto o parcialmente correcto */}
								{(correcto || parcialmenteCorrecto) && (
									<div style={{display:'flex', alignItems:'center', gap:'16px', marginBottom:'20px', padding:'14px', background:'#f6fff8', border:'1px solid #c3e6cb', borderRadius:'6px'}}>
										<QRCode value={qrUrl} size={80} />
										<div>
											<div style={{fontSize:'12px', color:'#155724', fontWeight:'600', marginBottom:'4px'}}>Registrada correctamente en la AEAT</div>
											<a href={qrUrl} target="_blank" rel="noopener noreferrer" style={{fontSize:'11px', color:'#007bff'}}>Verificar en sede electrónica →</a>
										</div>
									</div>
								)}

								{/* Sin actividad */}
								{entries.length === 0 && (
									<div style={{color:'#888', fontSize:'13px', textAlign:'center', padding:'20px 0'}}>
										Esta factura no ha sido enviada a Verifactu todavía.
									</div>
								)}

								{/* Historial de envíos */}
								{entries.length > 0 && (
									<div>
										<div style={{fontSize:'12px', fontWeight:'600', color:'#444', marginBottom:'10px'}}>
											Historial de envíos ({entries.length})
										</div>
										{entries.map((e, idx) => (
											<div key={String(e._id)} style={{
												marginBottom:'10px',
												border:'1px solid #dee2e6',
												borderRadius:'6px',
												overflow:'hidden',
												opacity: idx > 0 ? 0.85 : 1
											}}>
												{/* Cabecera del envío */}
												<div style={{padding:'8px 12px', background: idx === 0 ? '#f8f9fa' : '#fafafa', display:'flex', alignItems:'center', gap:'8px', flexWrap:'wrap'}}>
													<span style={{fontSize:'11px', color:'#888', flexShrink:0}}>
														#{entries.length - idx} · {e.createdAt ? new Date(e.createdAt).toLocaleString('es-ES') : '—'}
													</span>
													{idx === 0 && <span style={{fontSize:'10px', background:'#007bff', color:'#fff', borderRadius:'3px', padding:'1px 6px'}}>último</span>}
													<span style={{marginLeft:'auto', fontSize:'11px', fontWeight:'600', color: statusColor(e.status)}}>
														{e.status}{e.attempts > 0 ? ` · ${e.attempts} intento${e.attempts !== 1 ? 's' : ''}` : ''}
													</span>
													<button
														onClick={() => this.handleVerXml(e._id)}
														style={{background:'none', border:'1px solid #ccc', borderRadius:'4px', fontSize:'10px', cursor:'pointer', color:'#555', padding:'1px 7px'}}>
														Ver XML
													</button>
												</div>
												{/* Respuesta AEAT */}
												{e.result && (
													<div style={{padding:'8px 12px', borderTop:'1px solid #f0f0f0', fontSize:'12px'}}>
														<div style={{display:'flex', alignItems:'center', gap:'8px', marginBottom: e.result.errores?.length ? '6px' : 0}}>
															<span style={{color:'#666'}}>AEAT:</span>
															<span style={{fontWeight:'600', color: aeatColor(e.result.status)}}>{e.result.status || '—'}</span>
															{e.result.csv && <span style={{marginLeft:'auto', color:'#555', fontFamily:'monospace', fontSize:'11px'}}>CSV: {e.result.csv}</span>}
														</div>
														{e.result.errores && e.result.errores.length > 0 && (
															<ul style={{margin:0, paddingLeft:'18px', color:'#dc3545', fontSize:'12px'}}>
																{e.result.errores.map((err, i) => <li key={i}>{err}</li>)}
															</ul>
														)}
													</div>
												)}
												{/* Error interno (sin respuesta AEAT) */}
												{e.lastError && !e.result && (
													<div style={{padding:'8px 12px', borderTop:'1px solid #f0f0f0', fontSize:'11px', color:'#dc3545', fontFamily:'monospace', wordBreak:'break-word'}}>
														{e.lastError}
													</div>
												)}
												{/* Fechas */}
												{e.lastAttemptAt && (
													<div style={{padding:'4px 12px 8px', fontSize:'11px', color:'#999'}}>
														Último intento: {new Date(e.lastAttemptAt).toLocaleString('es-ES')}
														{e.nextRetryAt && e.status === 'retrying' && ` · Próximo: ${new Date(e.nextRetryAt).toLocaleString('es-ES')}`}
													</div>
												)}
											</div>
										))}
									</div>
								)}
							</div>
							{/* Footer */}
							<div style={{padding:'14px 20px', borderTop:'1px solid #dee2e6'}}>
								{this.state.reencolarError && (
									<div style={{marginBottom:'10px', padding:'8px 12px', background:'#f8d7da', border:'1px solid #f5c6cb', borderRadius:'4px', color:'#721c24', fontSize:'13px'}}>
										{this.state.reencolarError}
									</div>
								)}
								<div style={{display:'flex', justifyContent:'flex-end', gap:'8px'}}>
									{!correcto && !parcialmenteCorrecto && (
										<button
											className='btn btn-primary btn-sm'
											disabled={!!this.state.reencolando || !!pendiente}
											onClick={this.reencolar}
										>
											{this.state.reencolando ? 'Encolando…' : 'Reencolar'}
										</button>
									)}
									<button className='btn btn-secondary btn-sm' onClick={() => this.setState({verifactuModalOpen: false, reencolarError: null})}>
										Cerrar
									</button>
								</div>
							</div>
						</div>
					</>
				);
			})() : null}

			{/* Modal XML viewer */}
			{this.state.xmlModal && (
				<div style={{
					position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.55)', zIndex: 9999,
					display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '16px'
				}} onClick={() => this.setState({ xmlModal: null })}>
					<div style={{
						background: '#1e1e2e', borderRadius: '10px', width: '100%', maxWidth: '900px',
						maxHeight: '85vh', display: 'flex', flexDirection: 'column', boxShadow: '0 20px 60px rgba(0,0,0,0.5)'
					}} onClick={e => e.stopPropagation()}>
						<div style={{ display: 'flex', alignItems: 'center', gap: '12px', padding: '14px 18px', borderBottom: '1px solid #313244' }}>
							<span style={{ fontWeight: 700, color: '#cdd6f4', fontSize: '14px' }}>XML Verifactu</span>
							<span style={{ fontFamily: 'monospace', fontSize: '11px', color: '#6c7086' }}>{this.state.xmlModal.queueId}</span>
							<div style={{ marginLeft: 'auto', display: 'flex', gap: '6px' }}>
								{['sent', 'received'].map(tab => (
									<button key={tab}
										onClick={() => this.setState(s => ({ xmlModal: { ...s.xmlModal, tab } }))}
										style={{
											border: 'none', borderRadius: '6px', padding: '4px 14px', fontSize: '12px', cursor: 'pointer', fontWeight: 600,
											background: this.state.xmlModal.tab === tab ? '#89b4fa' : '#313244',
											color: this.state.xmlModal.tab === tab ? '#1e1e2e' : '#cdd6f4'
										}}>
										{tab === 'sent' ? 'Enviado' : 'Respuesta AEAT'}
									</button>
								))}
								<button onClick={() => this.setState({ xmlModal: null })}
									style={{ border: 'none', background: '#313244', color: '#f38ba8', borderRadius: '6px', padding: '4px 10px', cursor: 'pointer', fontWeight: 700, fontSize: '13px' }}>
									✕
								</button>
							</div>
						</div>
						<div style={{ overflow: 'auto', flex: 1, padding: '16px' }}>
							{this.state.xmlModal.tab === 'received' && this.state.xmlModal.xml_received &&
								<ServidorAeatInfo servidor={this.state.xmlModal.servidor_aeat} />
							}
							{(this.state.xmlModal.tab === 'sent' ? this.state.xmlModal.xml_sent : this.state.xmlModal.xml_received)
								? <pre style={{ margin: 0, fontFamily: 'monospace', fontSize: '12px', color: '#cdd6f4', whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
									{prettyXml(this.state.xmlModal.tab === 'sent' ? this.state.xmlModal.xml_sent : this.state.xmlModal.xml_received)}
								  </pre>
								: <div style={{ color: '#6c7086', textAlign: 'center', padding: '40px', fontSize: '13px' }}>
									{['pending', 'processing', 'retrying'].includes(this.state.xmlModal.queue_status)
										? 'El XML se generará cuando el worker procese este envío. Recarga en unos segundos.'
										: 'No disponible — este registro fue procesado antes de que se activara el guardado de XML'}
								  </div>
							}
						</div>
						<div style={{ padding: '10px 18px', borderTop: '1px solid #313244', display: 'flex', justifyContent: 'flex-end' }}>
							<button className="btn btn-sm btn-outline-secondary" style={{ fontSize: '12px', color: '#cdd6f4', borderColor: '#45475a' }}
								onClick={() => {
									const text = this.state.xmlModal.tab === 'sent' ? this.state.xmlModal.xml_sent : this.state.xmlModal.xml_received;
									if (text) navigator.clipboard.writeText(text);
								}}>
								Copiar al portapapeles
							</button>
						</div>
					</div>
				</div>
			)}

			{/* COMIENZO Documento para imprimir albaran en PDF */}
			<div style={{display:'none'}}> 
				<div ref={el => (this.componentRef = el)}>
					{this.displayBillHeader()}
					{this.displayBillBody()}
				</div>
			</div>
			{/* FIN Documento para imprimir albaran en PDF */}
			</>
        );
    }
}

const mapStateToProps = state => {
    return {
    };
}

const mapDispatchToProps = dispatch => {
    return {
        setModalContent(modalContent){
	    	dispatch(setModalContent(modalContent));
		}
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(EditBill)
